import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";

/**
 * paramInfoの内容に従って、$elementを生成する関数
 *
 * @param {String} pk
 * @param {Object} pi
 * @param {String} className
 * @returns $Object
 */
function _createEmptyElementByParamInfo(pk, pi, className) {
	const module = this.container.module;
	
	switch(pi.inpType) {
		case "radio":
		case "flg": {
			return $("<span/>").addClass(className).text(pk);
		}
		
		case "checkbox": {
			return $.fn.append.apply(
				$("<div/>"),
				[...Array(2)].map(() => $("<span/>").addClass(className).text(pk))
			).children();
		}
		
		case "date": {
			return $("<span/>").addClass(className).text(module.config.dateFormat);
		}
		
		case "datetime": {
			return $("<span/>").addClass(className).append(
				$("<span/>").addClass("day").text(module.config.dateFormat),
				$("<span/>").addClass("time").text(module.config.timeFormat)
			);
		}
		
		case "period": {
			u_.isBoolean(pi.hasTime) || (pi.hasTime = true);
			
			const $elm = $("<span/>").attr("data-period", "start").append(
				$("<span/>").addClass("day").text(module.config.dateFormat)
			).addClass(pi.hasTime ? "type-datetime" : "type-date");
			
			pi.hasTime && $elm.append(
				$("<span/>").addClass("time").text(module.config.timeFormat)
			);
			
			return $("<span/>").addClass(`${className} is-same-day`).append(
				$elm,
				$("<span/>").addClass("period-splitter"),
				$elm.clone().attr("data-period", "end")
			);
		}
		
		case "link": {
			return $("<a/>").addClass(`${className} change-state`).attr({
				target: "_blank",
				href: "./",
			}).append( $("<span/>").text(pk) );
		}
		
		case "file": {
			const $elm = $("<div/>").addClass(`${className} type-${pi.dataType}`);
			
			switch(pi.dataType) {
				case "img": {
					$("<img/>").appendTo($elm);
					!!pi.caption && $("<span/>").addClass("caption").text(pk).appendTo($elm);
					break;
				}
				
				case "pdf": {
					$("<a/>").attr({
						target: "_blank",
						href: "./blank.pdf"
					}).append( $("<span/>").text(pk) ).appendTo($elm);
					break;
				}
				
				case "video": {
					$("<video/>").appendTo($elm);
					!!pi.caption && $("<span/>").addClass("caption").text(pk).appendTo($elm);
					break;
				}
				
				case "office": {
					$("<a/>").attr({
						target: "_blank",
						href: "./blank.csv"
					}).append( $("<span/>").text(pk) ).appendTo($elm);
					break;
				}
				
				default: {
					csl.warn(`undefined file's dataType: ${pi.dataType}`);
					break;
				}
			}
			
			return $elm;
		}
		
		case "textarea": {
			return $(`<${!pi.isBlock ? "p" : "div"}/>`).addClass(className).append(
				$(`<${!pi.isBlock ? "span" : "p"}/>`).text(pk)
			);
		}
		
		case "html":
		case "wysiwyg": {
			return $("<div/>").addClass(className).append( $("<p/>").text(pk) );
		}
		
		case "password": {
			return $("<em/>").addClass(className).text(pk);
		}
		
		default: {	// text, nubmer, select
			const $elm = $("<span/>").addClass(className).text(pk);
			!!pi.unit && $elm.append( $("<span/>").addClass("unit").text(pi.unit) );
			return $elm;
		}
	}
}

export default _createEmptyElementByParamInfo;
